import React from 'react';
import { motion } from 'framer-motion';
import styles from './FeedeskHero.module.css';
import FeedeskHeroImg from '../../assets/feedesk-imgs/FeedeskHeroImg.png';

const FeedeskHero = ({ setIsRegisterOpen }) => {
  return (
    <section className={styles.heroWrapper}>
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className={styles.leftContent}
      >
        <span className={styles.tagline}>Tuition Fee Collection · Simplified</span>
        <h1 className={styles.heading}>
          <span className={styles.headingBlue}>Feedesk</span>{' '}
          <span className={styles.headingOrange}>— Smart Fee Tracking and Automation</span>
        </h1>

        <p className={styles.subtext}>
          From creating batch-wise fees to collecting payments and issuing receipts,
          Feedesk brings your entire tuition finance flow into one clean dashboard.
        </p>

        <p className={styles.supportText}>
          Secure, transparent, and fast collections for every batch.
        </p>

        <div className={styles.actions}>
          <button
            className={styles.btnPrimary}
            onClick={() => setIsRegisterOpen(true)}
          >
            Get Started Free
          </button>
        </div>

        <div className={styles.trustRow}>
          <span>✓ No setup fee</span>
          <span>✓ Works for any batch size</span>
          <span>✓ UPI &amp; cash supported</span>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 40 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.15 }}
        className={styles.rightContent}
      >
        <div className={styles.heroImageWrapper}>
          <img
            src={FeedeskHeroImg}
            alt="Feedesk hero image"
            className={styles.heroImage}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default FeedeskHero;